import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/449718661b99bc1dc524f4d7110e20bf/381ff4af4f0606b60234e65040da7b54.png" 
              alt="Logo" 
              className="h-16 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-white/80 mb-6 leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="flex gap-3">
              <button className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </button>
              <button className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </button>
              <button className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-colors cursor-pointer">
                <i className="ri-twitter-fill"></i>
              </button>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 uppercase tracking-wider">{t('footer.services.title')}</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white transition-colors text-left">
                  {t('footer.services.tax')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white transition-colors text-left">
                  {t('footer.services.planning')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white transition-colors text-left">
                  {t('footer.services.patronage')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white transition-colors text-left">
                  {t('footer.services.accounting')}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 uppercase tracking-wider">{t('footer.quickLinks')}</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-white/80 hover:text-white transition-colors text-left">
                  {t('nav.about')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('portfolio')} className="text-white/80 hover:text-white transition-colors text-left">
                  {t('nav.portfolio')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('blog')} className="text-white/80 hover:text-white transition-colors text-left">
                  {t('nav.blog')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-white/80 hover:text-white transition-colors text-left">
                  {t('nav.contact')}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 uppercase tracking-wider">{t('footer.newsletter.title')}</h3>
            <p className="text-white/80 mb-4">
              {t('footer.newsletter.description')}
            </p>
            <div className="space-y-3 text-white/80 text-sm">
              <p><i className="ri-map-pin-line mr-2"></i>Via Marengo, 6 - Chiari - Brescia</p>
              <p><i className="ri-phone-line mr-2"></i>030 712 316</p>
              <p><i className="ri-smartphone-line mr-2"></i>375 693 5807</p>
              <p><i className="ri-mail-line mr-2"></i>stefania.navoni@enasc.eu</p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/70 text-sm">
              {t('footer.copyright')}
            </p>
            <div className="flex items-center gap-6 text-sm">
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white/70 hover:text-white transition-colors"
              >
                {t('footer.poweredBy')} Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
